import reducerRegistry from 'core/lib/store/reducer-registry';
import {
  GLOBAL_CONFIG,
  GLOBAL_CONFIG_SUCCESS,
  GLOBAL_CONFIG_ERROR,
} from "@/action-types/userInfo";
import globalConfig from '../reducers/globalConfig'

reducerRegistry.register('globalConfig', globalConfig)

export function setGlobalConfig(callback) {
  return {
    types: [GLOBAL_CONFIG, GLOBAL_CONFIG_SUCCESS, GLOBAL_CONFIG_ERROR],
    callAPI: () => callback()
  };
}
